import React from "react"
import pulaLogo from "../../assets/images/pula-logo.svg"

export const LoginHeader = () => {
  return (
    <header className="login-header">
      <img src={pulaLogo} className="logo d-block m-auto" alt="Pula logo" />
      <div className="header-text">
        <h1 className="welcome-title">
          Welcome to <span className="primarytext">the World of PULA!</span>
        </h1>
        <p className="welcome-subtitle">Sign in to continue</p>
      </div>
    </header>
  )
}
